/* 🤖 this file was generated by svg-to-ts */
export const matIconCropPortrait: {
  name: 'crop-portrait';
  data: string;
} = {
  name: 'crop-portrait',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"/></svg>`
};
